export default __webpack_public_path__ + "static/media/image.eae03792.png";